$(document).ready(function () {
    $('.product-slide').slick({
        dots: false,
        infinite: false,
        arrows: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 769,
            settings: "unslick"
        }
    ]
    });
  var count_elements = $('.subcollections_item').length;
    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    if(width > 1024){
        if(count_elements > 6){
            $('.subcollections').slick({
                dots: false,
                infinite: true,
                arrows: true,
                speed: 300,
                slidesToShow: 6,
                slidesToScroll: 1,
                responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                }
            ]
            });
        }
    }else{
        if(count_elements > 3){
            $('.subcollections').slick({
                dots: false,
                infinite: true,
                arrows: true,
                speed: 300,
                slidesToShow: 6,
                slidesToScroll: 1,
                responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                }
            ]
            });
        }
    }
        
    if ($(window).width() > 768) {
        $('.product__main-photos .show-more-content').append('<span class="show_more">'+$('.product__main-photos .show-more-content').data('left')+' more photos - <a href="#">See All</a></span>')
    }
    $('.show_more a').on('click', function (e) {
        e.preventDefault();
        $('.product__main-photos > div').addClass('show-all');
        $('.product__thumbs').addClass('show-all');
    });
    $(document).on('click', '.flits-tingle-modal-box__content .flits-tingle-btn', function (e) {
        e.preventDefault();
        location = '/account';
    })
    $(document).on('click', '.review-info .review_btn', function(e){
        e.preventDefault();
        if (!$('button[aria-controls="Product-content-84739a55-4964-4eb1-93ee-418228c881e3"]').hasClass('is-open')) {
            $('button[aria-controls="Product-content-84739a55-4964-4eb1-93ee-418228c881e3"]').trigger('click');
            setTimeout(() => {
                if ($(window).width > 768) {
                    window.scroll( {
                        top: 500,
                        behavior: 'smooth'
                    });
                } else {
                    window.scroll( {
                        top: 1000,
                        behavior: 'smooth'
                    });
                }
                
            }, 550);
            
        }
       
    });
    $(document).on('click', '.additionalList .collapsible-trigger-btn', function (e) {
        e.preventDefault();
        
        setTimeout(() => {
            var height = $('.product-single__meta.desktop').height() + 237;
            var document_height = $(window).height();
            console.log(document_height);
            console.log(height);
            var left_height = height - document_height;
            if (left_height > 180) {
                var left_height = height - document_height;
                $('.page-content--product>.grid .product-single__meta').css({
                    'top': 180 - left_height
                })
            } else {
                $('.page-content--product>.grid .product-single__meta').css({
                    'top': ''
                })
            }
            
        }, 500);
    });
    var height = $('.product-single__meta.desktop').height() + 237;
    var document_height = $(window).height();
    console.log(document_height);
    console.log(height);
    if (height > document_height) {
        var left_height = height - document_height;
        $('.page-content--product>.grid .product-single__meta').css({
            'top': 180 - left_height
        })
    }
});